module.exports = __webpack_public_path__ + "static/media/Inshan Books(1).ad871db1.png";